(() => {
    window.Dashboard = window.Dashboard || {};

    window.Dashboard.Models = window.Dashboard.Models || {};
    window.Dashboard.Models.Lookups = window.Dashboard.Models.Lookups || {};

    /**
     * Lookup for permissions
     * @constructor
     */
    Dashboard.Models.Lookups.Permissions = {
        AcceptOnlineOrders: "AcceptOnlineOrders",
        ActionRefunds: "ActionRefunds",
        ActivateCampaigns: "ActivateCampaigns",
        BrandCustomerSupportAgent: "BrandCustomerSupportAgent",
        CampaignDesignerAccess: "CampaignDesignerAccess",
        DashboardAccess: "DashboardAccess",
        ManageCampaigns: "ManageCampaigns",
        ManageDeliveryZones: "ManageDeliveryZones",
        ManageUsers: "ManageUsers",
        OrdersAccess: "OrdersAccess",
        OutOfStock: "OutOfStock",
        ReportsAccess: "ReportsAccess",
        StoreSettings: "StoreSettings",
        ViewLandingPages: "ViewLandingPages",
        ViewOnlineOrders: "ViewOnlineOrders",
        ViewUsers: "ViewUsers",
        AddLandingPage: "AddLandingPage",
        EditLandingPage: "EditLandingPage",
        DeleteLandingPage: "DeleteLandingPage",
        ManageNonAdminUsers: "ManageNonAdminUsers",
    };
})();
